import { Component, OnInit, Renderer2, ChangeDetectionStrategy } from '@angular/core';
import { Action, ActionReducer, State, Store, createAction, props } from '@ngrx/store';

// actions.ts
const storageActionType = '@ngrx/store/storage';

export const storageAction = createAction(
	storageActionType,
	props<{ payload: string }>()
);

type PayloadAction = Action & {
	payload: unknown;
};


// reducers.ts
import { Keys, localStorageSync, rehydrateApplicationState } from 'ngrx-store-localstorage';
import { AppState } from './common/store/state/app.state';


export const localStorageSyncReducer = (reducer: ActionReducer<any>): ActionReducer<any> => (state: State<any>, action: Action): any => {
	const keys = ['key1', 'key2'];

	const isPayloadAction = 'payload' in action;
	const payloadAction: PayloadAction = action as PayloadAction;

	if (action.type === storageActionType && isPayloadAction && keys.includes(payloadAction.payload as string)) {
		
    const rehydratedState = rehydrateApplicationState({ 
      keys: [payloadAction.payload] as Keys, 
      storage: localStorage, 
      storageKeySerializer: k => k, 
      restoreDates: true 
    });
    
		return { ...state, ...rehydratedState };
	}

	return localStorageSync({
		keys,
		rehydrate: true,
	})(reducer)(state, action);
};

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})

// app.component.ts
export class AppComponent implements OnInit {

  title = 'africcar-app';

  constructor(
    private readonly renderer: Renderer2,
    private readonly store: Store<State<any>>
  ) {}

  ngOnInit() {
    this.renderer.listen('window', 'storage', event => {
      this.store.dispatch(storageAction({ payload: event.key as string }));
    });
  }
}
